<template>
  <el-dialog
    title="耗材类型"
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
    key="1"
    :modal="false"
    :before-close="handleDialogClose">
    <div>
      <el-form v-if="visible" :model="formData" ref="mallConsumablesDialogForm" label-width="150px" class="dialog-form-wrap">
        <el-form-item label="原库存数：" prop="inventoryorg" v-if="formData.id">
          <span>{{formData.inventoryorg}}</span>
        </el-form-item>
        <el-form-item label="耗材类型：" prop="name"
          :rules="[
            { required: true, message: '耗材类型不能为空'}
          ]"
        >
          <el-input v-model.trim="formData.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="库存数：" prop="inventory"
          :rules="[
            { required: true, message: '库存数不能为空'},
            { pattern: /^[+]{0,1}(\d+)$/, message: '请输入不小于0的整数', trigger: 'blur' }
          ]"
        >
          <el-input v-model.trim="formData.inventory" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input type="textarea" v-model.trim="formData.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleDialogClose">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'MallConsumablesEditPage',
  props: ['visible', 'formData'],
  isAutoComponent: true,
  data() {
    return {
    }
  },
  methods: {
    handleDialogClose() {
      this.$emit('update:visible', false)
    },
    submitForm() {
      const that = this
      this.$refs.mallConsumablesDialogForm.validate((valid) => {
        if (valid) {
          if (that.formData.id) { // 编辑
            that.$api.mall.consumables.consumablesUpdate(that.formData).then(res => {
              that.toSuccess()
            })
          } else {
            that.$api.mall.consumables.consumablesAdd(that.formData).then(res => {
              that.toSuccess()
            })
          }
        } else {
          return false
        }
      })
    },
    toSuccess() {
      this.$message({ message: '保存成功', type: 'success' })
      this.handleDialogClose()
      this.$emit('refreshData')
    }
  }
}
</script>

<style>
</style>
